export default {
  path: '/applications',
  name: 'applications',
  component: () => import('../components/application/Layout'),
  redirect: { name: 'ApplicationList' },
  meta: {
    breadcrumb: 'app.apps',
  },
  children: [
    {
      name: 'ApplicationList',
      path: '',
      component: () => import('../views/application/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ApplicationConnectorList',
      path: 'connector',
      component: () => import('../views/application/ConnectorList'),
      meta: {
        breadcrumb: 'global.list',
      },
    },   
    {
      name: 'ApplicationCreate',
      path: 'new',
      component: () => import('../views/application/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ApplicationUpdate',
      path: ':id/edit',
      component: () => import('../views/application/Update'),
      meta: {
        breadcrumb: 'app.app',
      },
    },
    {
      name: 'ApplicationShow',
      path: ':id',
      component: () => import('../views/application/Show'),
      meta: {
        breadcrumb: 'app.app',
      },
    }
  ]
};
